export default __webpack_public_path__ + "static/media/lock.df549254.gif";